const GET_FIRST_NUMBER = /[-\d.,]+/;
const GET_NUMBER_WITH_FRACTION = /((?<first>-?\d+)?\s)?((?<above>-?\d+)\/(?<below>\d+)")/;

/**
 * used to normalize numeric attribute values for sorting
 * "0.16 m³/h" -> "160"
 * "180 mm" -> "180000"
 * "75 N" -> "75000"
 * @param value
 */
export function parseIntegerValue(value: string): string {
    let parsed = value;
    const matchFraction = parsed.match(GET_NUMBER_WITH_FRACTION);
    if (parsed.split('/').length === 2 && matchFraction && matchFraction.groups) {
        let fractioned = '0';
        if (matchFraction.groups.first) {
            fractioned = matchFraction.groups.first;
        }
        if (matchFraction.groups.above && matchFraction.groups.below) {
            const first = parseFloat(fractioned);
            parsed = (
                first + (
                    (first < 0 ? -1 : 1) *
                    (parseFloat(matchFraction.groups.above) / parseFloat(matchFraction.groups.below))
                )
            ).toString();
        }
    }

    const match = parsed.match(GET_FIRST_NUMBER);
    if (match && match[0]) {
        // eslint-disable-next-line prefer-destructuring
        parsed = match[0];
    }
    return (parseFloat(parsed.replace(/[^-0-9,.]/ig, '')) * 1000).toString();
}
